module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/golden_pin_concept_award_logo-6c54b83d25bd3c491ebeff2116d4c254.svg&quot;;"